"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrAccordionItem = void 0;
const react_1 = __importStar(require("react"));
const libs_context_ios_scroll_block_1 = require("@hotelplan/libs.context.ios-scroll-block");
const fdr_accordion_styles_1 = require("./fdr-accordion.styles");
const DEFAULT_FDR_ACCORDION_ICON_NAME = 'chevron-left';
function FdrAccordionItem({ title, active, onOpen, onClose, children, className, testId, customIcon, scrollable = false, AccordionButtonComponent = fdr_accordion_styles_1.DefaultFdrAccordionButton, }) {
    const activeClass = active ? 'active' : '';
    const contentRef = (0, react_1.useRef)(null);
    (0, libs_context_ios_scroll_block_1.useScrollElement)(contentRef, scrollable);
    const iconName = customIcon
        ? active
            ? customIcon.activeIcon
            : customIcon.inactiveIcon || customIcon.activeIcon
        : DEFAULT_FDR_ACCORDION_ICON_NAME;
    return (react_1.default.createElement(fdr_accordion_styles_1.FdrAccordionItemWrap, { className: `accordionItem ${activeClass} ${className}` },
        react_1.default.createElement("div", { className: "accordionButtonWrap" },
            react_1.default.createElement(AccordionButtonComponent, { variant: "accordionBtn", "data-id": testId, className: `accordionButton ${activeClass}`, onClick: (e) => {
                    e === null || e === void 0 ? void 0 : e.preventDefault();
                    active ? onClose() : onOpen();
                } },
                title,
                react_1.default.createElement(fdr_accordion_styles_1.FdrAccordionIcon, { className: "chevron", active: active, name: iconName }))),
        react_1.default.createElement("div", { ref: contentRef, className: `accordionContent ${activeClass} ${scrollable ? 'scrollable' : ''}` }, typeof children === 'function' ? children(active || false) : children)));
}
exports.FdrAccordionItem = FdrAccordionItem;
//# sourceMappingURL=fdr-accordion-item.js.map